var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongformH1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 10,
  viewBox: "0 0 17 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.013 9.858h4.03v-.736l-1.13-.235V5.459H7.16v3.434l-1.13.235v.73h4.088v-.73l-1.136-.241V.984l1.073-.127V0H6.1v.857l1.06.12v3.466H2.914V.983L3.98.858V0H0v.857L1.085.99v7.89l-1.072.242zm11.292 0h5.091v-.762l-1.593-.216.025-6.95-.66-.108c-.311.247-2.253 1.123-3.053 1.345l.184.857c.558-.088 1.282-.19 1.745-.266v5.116l-1.739.222z"
})));
export default SvgLongformH1;